var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 40 40"
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h32a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z",
    style: {
      fill: "#134038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.293.293 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582zm3.53-.768c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#28736d"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "amex_svg__a",
    d: "M27 19h10v10H27z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "amex_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#amex_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#amex_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 19H27v10h10V19z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 19v10h10v-1.58h-1.38l-.51-.597-.53.597h-3.92v-3.177h-1.293l1.617-3.66h1.573l.38.83v-.83h1.953l.327.87.32-.87H37V19H27zm8.87 2.1-.513 1.353-.137.367-.14-.367-.517-1.353h-1.13v2.667h.68V22.03l-.003-.35.133.35.65 1.737h.647l.653-1.737.127-.347v2.083H37V21.1h-1.13zm-4.52 0-1.18 2.667h.773l.207-.513h1.293l.207.513h.783L32.26 21.1h-.91zm.313.903.133-.333.133.333.277.673h-.82l.277-.673zm4.26 2.244-.803.863-.8-.863h-3.114v2.657h2.227v-.577h-1.547v-.463h1.517v-.574h-1.517v-.467h1.547v-.577l1.243 1.333-1.243 1.323h.86l.81-.867.807.867h.883l-1.247-1.333 1.247-1.323h-.87zm.324 1.32.753.766V24.81l-.753.757z",
    style: {
      fill: "#006fcf"
    }
  })));
};
export default SvgAmex;